import React, { useState } from "react";
import { PatchContentViews } from "../types/global";
import { TierListTable, DefaultCompList, PatchContentHeader, STierView } from "src/components";

function PatchContentSection() {
  const [selectedView, setSelectedView] = useState<PatchContentViews>(PatchContentViews.S_TIER);

  const getPatchContentView = () => {
    switch (selectedView) {
      case PatchContentViews.S_TIER:
        return <STierView />;
      case PatchContentViews.STATS:
        return <TierListTable />;
      case PatchContentViews.COMPS:
        return <DefaultCompList />;
    }
  };

  return (
    <div className="flex  w-full max-w-[1855px] flex-col items-center justify-center gap-10  px-20 pt-10 max-[615px]:px-10 max-[533px]:px-5">
      <div className="flex w-full items-center justify-start">
        <div className=" font-unbounded text-[20px] leading-6 text-neutral-0">
          <span className="font-extrabold">PATCH 25.S1.1</span> {""}
          <span className="font-light">ANALYSIS</span>
        </div>
      </div>
      <PatchContentHeader selectedView={selectedView} setSelectedView={setSelectedView} />
      {getPatchContentView()}
    </div>
  );
}

export default PatchContentSection;
